







































import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component
export default class FinanceControl extends Vue {
    constructor() {
        super();
    }

    get stripeConnected(): boolean {
        return this.$store.getters['FinanceControl/corporationStripeConnectionStatus'];
    }

    public disconnectStripe() {
        this.$store.dispatch(Actions.DISCONNECT_STRIPE_ACCOUNT_TO_CORPORATION);
    }

    public created() {
        this.$store.dispatch(Actions.CHECK_CORPORATION_STRIPE_CONNECTION_STATUS);
        if (typeof this.$route !== 'undefined') {
            if (typeof this.$route.query.code !== 'undefined') {
                this.$store.dispatch(Actions.CONNECT_STRIPE_ACCOUNT_TO_CORPORATION, {code: this.$route.query.code});
            }
        }
    }
}
